export enum FeeProfileType {
  Manual = 'manual',
  Filters = 'filters',
}

export enum FeeProfileTypeText {
  'manual' = 'Manuale',
  'filters' = 'Filtri',
}
